import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translations using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Configure language detection
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'eyehill_language',
      checkWhitelist: true
    },

    // Configure backend to load translation files
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      addPath: '/locales/{{lng}}/translation.json'
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Supported languages
    supportedLngs: ['en', 'he'],

    // Namespace configuration
    ns: ['translation'],
    defaultNS: 'translation',

    // React specific options
    react: {
      useSuspense: false // Disable suspense to avoid loading states
    }
  });

// Function to change language and update document direction
export const changeLanguage = (lng) => {
  // Check if language is locked
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
  if (userData.lockedLanguage) {
    console.warn('Language is locked to:', userData.lockedLanguage);
    return; // Don't allow language change if locked
  }

  i18n.changeLanguage(lng);
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  // Store in localStorage
  localStorage.setItem('eyehill_language', lng);
};

// Initialize document direction based on current language
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

// Set initial direction immediately to prevent RTL flash on first load
// Check for locked language first (stored in user data)
const userData = JSON.parse(localStorage.getItem('user') || '{}');
const lockedLanguage = userData.lockedLanguage;
const currentLang = lockedLanguage || localStorage.getItem('eyehill_language') || 'en';
const initialDir = currentLang === 'he' ? 'rtl' : 'ltr';
// Force LTR as default to prevent race condition on first load
document.documentElement.dir = initialDir;
document.documentElement.lang = currentLang;

// If language is locked, ensure i18n uses that language
if (lockedLanguage) {
  i18n.changeLanguage(lockedLanguage);
}

export default i18n;